import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import {CoreModule} from "./core/core.module";
import {FeatureModule} from "./feature/feature.module";
import {SharedModule} from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import {CookieService} from "ngx-cookie-service";


@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, CoreModule, FeatureModule, SharedModule, AppRoutingModule],
  providers: [CookieService],
  bootstrap: [AppComponent],
})
export class AppModule {}
